export default "__VITE_ASSET__pnkrjuLk__"